<template>
  <div class="">
    <div class=" font-test">
      <!-- 顶部菜单栏和视频区 -->
      <!-- <div class="top-banner"> -->
      <!-- 关于我们顶部菜单 -->
      <aboutsPageTopPc />
      <!-- </div> -->
      <div class="content-box app-container">
        <el-image class="app_all" :src="contentList[language]" width="100%" lazy @load="imgOnload">
          <div slot="placeholder" class="image-slot">
            {{$t('加载中')}}<span class="dot">...</span>
          </div>
        </el-image>
        <div class="" v-show="['en'].includes(language)" v-if="showBtn">
          <a v-if="language != 'zh'" class="app_Google1" href=" https://play.google.com/store/apps/details?id=com.tripellet.app" target="_blank" rel="noopener noreferrer">
            <el-image :src="appGoogle" width="100%" lazy></el-image>
          </a>
          <a class="app_Store1" href="https://apps.apple.com/tw/app/travel-contents-%E6%97%85%E9%81%8A%E6%8E%A7/id1597706553" target="_blank" rel="noopener noreferrer">
            <el-image :src="appStore" width="100%" lazy></el-image>
          </a>
        </div>
        <div class="" v-show="['zh','zh_tw','ko'].includes(language)" v-if="showBtn">
          <a v-if="language != 'zh'" class="app_Google" href=" https://play.google.com/store/apps/details?id=com.tripellet.app" target="_blank" rel="noopener noreferrer">
            <el-image :src="appGoogle" width="100%" lazy></el-image>
          </a>
          <a class="app_Store" href="https://apps.apple.com/tw/app/travel-contents-%E6%97%85%E9%81%8A%E6%8E%A7/id1597706553" target="_blank" rel="noopener noreferrer">
            <el-image :src="appStore" width="100%" lazy></el-image>
          </a>
        </div>
      </div>
    </div>
    <el-image class="app_Footer" :src="appFooter" width="100%" lazy></el-image>
  </div>
</template>

<script>
import { aboutBannerList, homeLanList } from '@/utils/public_data'

import aboutsPageTopPc from '@/components/aboutsPage-top-pc'
export default {
  data() {
    return {
      logo: require("@/assets/images/customer/PC-home.png"),
      activeIndex: '2',
      lanLogo: require("@/assets/images/customer/PC_line.png"),
      appGoogle: require("@/assets/images/aboutus/app_google.png"),
      appStore: require("@/assets/images/aboutus/app_store.png"),
      appFooter: require("@/assets/images/aboutus/app_footer.png"),
      lanList: homeLanList(),
      contentList: aboutBannerList(),
      showBtn: false,
    }
  },
  components: {
    aboutsPageTopPc
  },
  computed: {
    lan() {
      return this.lanList[localStorage.getItem("locale")]
    },
    language() {
      return localStorage.getItem("locale") || 'zh_tw'
    }
  },
  methods: {
    imgOnload() {
      this.showBtn = true
      this.$forceUpdate()
    }
  }
}
</script>
<style lang='scss' scoped>
.app_all {
  position: relative;
}
.app_Google {
  position: absolute;
  bottom: 216px;
  right: 358px;
  width: 101px;
}
.app_Store {
  position: absolute;
  bottom: 216px;
  right: 248px;
  width: 101px;
}
.app_Google1 {
  position: absolute;
  bottom: 154px;
  right: 358px;
  width: 101px;
}
.app_Store1 {
  position: absolute;
  bottom: 154px;
  right: 248px;
  width: 101px;
}
.app_Footer {
  // position: absolute;
  // bottom: 0;
  height: 64px;
  width: 100%;
}

@media screen and (min-width: 768px) and(max-width: 1024px) {
  .container {
    width: 760px;
    margin: 0 auto;
  }
}
.font-test {
  font-family: "GenJyuuGothic";
}
.app-container {
  width: 1000px;
  margin: 0 auto;
}
.container {
  width: 1000px;
  margin: 0 auto;
}
.test {
  z-index: 0;
}
.menu-text2 {
  text-align: center;
  overflow: hidden;
  color: #333;
  font-size: 16px;
}
.menu-text2:hover {
  background-color: #ecf5ff;
  color: #66b1ff;
}
.font-14 {
  font-size: 14px;
}
.color-green {
  color: #6aaf38;
}
.one-line {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.two-line {
  word-break: break-all;
  text-overflow: ellipsis;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
.top-banner {
  position: relative;
  height: 44px;
  z-index: 0;
  overflow: hidden;
  .top-banner-bg {
    position: absolute;
    width: 100%;
    height: 56px;
    left: 0;
    top: 80px;
    background: url("../../assets/images/bg/bg6.png") no-repeat;
    z-index: -11;
  }
  .top-banner-bg2 {
    position: absolute;
    right: -100px;
    top: -100px;
    width: 600px;
    height: 600px;
    background: #ffc64e;
    transform: rotate(21deg);
    border-radius: 40px;
    z-index: -1;
  }
}
.container {
  width: 1000px;
  margin: 0 auto;
}

::v-deep .el-input__inner {
  border: 0;
}
.searchForm-box {
  box-sizing: border-box;
  padding: 16px 30px;
  width: 1000px;
  height: 100px;
  margin: 0 auto;
  margin-top: 10px;
  background: #fff;
  border-radius: 15px;
  -moz-box-shadow: 2px 2px 10px rgba(248, 182, 42, 0.5);
  -webkit-box-shadow: 2px 2px 10px rgba(248, 182, 42, 0.5);
  box-shadow: 2px 2px 10px rgba(248, 182, 42, 0.5);
  .searchForm-title {
    display: flex;
    justify-content: space-between;
  }
}
.searchForm {
  margin-top: 10px;
  display: flex;
  justify-content: flex-start;
  border: 1px solid #333;
  border-radius: 5px;
  background: #fff4dc;
  .border-line {
    border-right: 1px solid #333;
  }
}
.near {
  cursor: pointer;
  // &:hover {
  //   color: #E7B530;
  // }
  line-height: 40px;
  padding: 0px 20px;
  text-align: center;
  font-size: 24px;
  // font-weight: 600;
  color: #333;
}
.video-box {
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: 1000px;
  height: 534px;
  margin: 24px auto 0px;
  background: #fff;
  border: 2px solid #dcdfe6;
  border-radius: 50px;
  z-index: 1000;
  .video-content {
    width: 880px;
    height: 496px;
    z-index: 100;
  }
}
.video-icon {
  width: 34px;
  cursor: pointer;
}
.bulletin-box {
  display: flex;
  width: 1000px;
  height: 45px;
  border: 1px solid #f8b62a;
  border-radius: 15px;
  .bulletin-left {
    padding: 0 20px;
    display: flex;
    justify-content: center;
    align-items: center;
    min-width: 70px;
    width: auto;
    height: 100%;
    background: #f8b62a;
    border-radius: 15px;
    color: #fff;
  }
}
.center-box {
  position: relative;
  width: 100%;
  background: #fff4dc;
  background-size: 140% 100%;
  background-position: -700px 0px;
  z-index: 0;
  .center-bg {
    margin-top: 30px;
    background: #f9f9f9;
    height: 1286px;
    overflow: hidden;
    z-index: 0;
    .center-bg1 {
      position: absolute;
      left: 0;
      top: 0px;
      width: 260px;
      height: 900px;
      background: url("../../assets/images/bg/bg2.png") no-repeat;
      z-index: 1;
    }
    .center-bg2 {
      position: absolute;
      top: 200px;
      right: 0;
      width: 280px;
      height: 550px;
      background: url("../../assets/images/bg/bg4.png") no-repeat;
      z-index: 1;
    }
    .center-bg3 {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 280px;
      height: 418px;
      background: url("../../assets/images/bg/bg3.png") no-repeat;
      z-index: 1;
    }
  }
}
.tab-box {
  margin-top: 30px;
  display: flex;
  ::v-deep .el-tabs__active-bar {
    color: #f8b62a;
    background-color: #f8b62a;
  }
  ::v-deep .is-active {
    color: #f8b62a;
    font-size: 6px;
  }
  ::v-deep .el-tabs__item {
    text-align: center;
    padding: 0px 10px;
    margin: 0;
    height: 45px;
    &:hover {
      color: #f8b62a;
    }
  }
  ::v-deep .is-active {
    color: #f8b62a;
  }
  ::v-deep .el-tabs__active-bar {
    text-align: center;
    margin: 0 auto;
    height: 4px;
    color: #f8b62a;
    background-color: #f8b62a;
  }
  ::v-deep .el-tabs__nav-wrap::after {
    background-color: rgba(255, 255, 255, 0);
  }
  .tab-title {
    padding: 0px 20px;
    text-align: center;
    font-size: 24px;
    font-weight: 600;
  }
}
.content-box {
  width: 1000px;
  // margin: 0 auto;
  display: flex;
  justify-content: space-around;
  margin-top: 4px;
  z-index: 100;
  position: relative;
  .left-banner {
    width: 486px;
    height: 1078px;
    border: 2px solid #e7b530;
    border-radius: 50px;
    z-index: 100;
    .left-title {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 0;
      border: 0;
      width: 100%;
      height: 68px;
      border-radius: 47px 47px 0 0;
      background: #e7b530;
      color: #fff;
      font-size: 24px;
      background: url("../../assets/images/bg/bg5.png");
    }
  }
}
.el-menu--horizontal > .el-menu-item.is-active {
  border-bottom: 4px solid #ffbb2c;
}
.swiper {
  margin-top: 30px;
  width: 100%;
  height: 900px;
  margin-left: auto;
  margin-right: auto;
  text-align: center;
  .swiper-slide {
    text-align: center;
    width: 400px;
    height: 250px;
  }
}
.bulletin-right {
  width: 90%;
}
.bulletin-swiper {
  margin-left: 20px;
  width: 100%;
  height: 45px;
  .swiper-slide {
    width: 100%;
    height: 45px;
  }
}
.menu-text {
  font-size: 16px;
  color: #333;
}
.right-list-box {
  width: 476px;
  z-index: 100;
  .right-title {
    display: flex;
    font-size: 23px;
    border-bottom: 3px solid #f8b62a;
    line-height: 20px;
    color: #f8b62a;
    padding-bottom: 13px;
    .right-img {
      margin-right: 20px;
      width: 30px;
      height: 24px;
    }
  }
  .right-list {
    width: 100%;
    .right-item {
      margin: 18px 0;
      width: 100%;
      height: 186px;
      border-radius: 25px;
      border: 2px solid #f8b62a;
      z-index: 100;
      cursor: pointer;
      .right-item-title {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        background: #f8b62a;
        width: 100%;
        height: 40px;
        border: 0;
        padding: 0;
        padding-left: 20px;
        box-sizing: border-box;
        border-radius: 22px 22px 0 0;
        color: #fff;
        font-size: 19px;
      }
      .right-item-content {
        padding: 0 24px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        box-sizing: border-box;
        width: 480px;
        height: 160px;
        .content-box {
          display: flex;
          flex-direction: column;
          justify-content: flex-start;
          align-items: flex-start;
          margin-top: 4px;
          .list-info-item {
            line-height: 1.5;
            width: 314px;
            font-size: 14px;
          }
        }
        .img-box {
          width: 100px;
          height: 120px;
          .right-item-img {
            width: 100px;
            height: 100px;
          }
        }
      }
    }
  }
}
.banner-item {
  border-radius: 35px;
  width: 400px;
  height: 250px;
  cursor: pointer;
}
.partner-box {
  width: 100%;
  height: 540px;
  background: #fff4dc;
  overflow: hidden;
  z-index: 1;
  .partner-title {
    margin-top: 78px;
    width: 1000px;
    height: 60px;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    color: #fff;
    background-image: linear-gradient(to right, #fff4dc, #f8b62a, #fff4dc);
    font-size: 22px;
  }
}
.partner-list {
  margin-top: 41px;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  .partner-item {
    margin-right: 25px;
    width: 180px;
    height: 180px;
    background: #fbf8fb;
  }
}
.bulletin-content {
  width: 96%;
  padding: 0 10px;
  box-sizing: border-box;
  height: 45px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.banner-btn {
  background: #ffbb2c;
  color: #fff;
  border: 1px solid #ffbb2c;
  border-radius: 0px 5px 5px 0;
}
</style>
<style lang="scss">
.el-menu--collapse .el-menu .el-submenu,
.el-menu--popup {
  min-width: 100px;
}
.swiper-pagination-bullet-active {
  opacity: 1;
  background: #f8b62a;
}
</style>